require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./recipes-aloo-paratha.json") })
        }
      }, "path---recipes-aloo-paratha");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---recipes-aloo-paratha!./.cache/json/recipes-aloo-paratha.json
// module id = 724
// module chunks = 231608221292675